<template>
  <base-modal ref="modal" @hiding="reset()">
    <base-card>
      <h3 class="tw-text-xl tw-font-thin">Choose Member Prescription</h3>
      <base-form ref="form" v-model="isFormValid" class="tw-mt-5">
        <base-select
          id="business-selecet"
          :disabled="isBusinessesLoading"
          light
          label="Business"
          placeholder="Choose the Business"
          :options="businesses"
          valueKey="id"
          labelKey="name"
          v-model="selectedBusinessId"
          required
        />
        <base-select
          id="prescription-selecet"
          class="tw-mt-6"
          :disabled="isPrescriptionLoading"
          light
          label="Prescription"
          placeholder="Choose the Prescription"
          :options="formattedPrescriptions"
          valueKey="businessPrescriptionId"
          labelKey="comboName"
          v-model="selectedPrescriptionId"
          required
        />
      </base-form>
      <div class="sm:tw-flex sm:tw-flex-row-reverse tw-mt-7">
        <base-button @click="save" :loading="isLoading" class="tw-w-full sm:tw-w-auto sm:tw-ml-3" :disabled="!isFormValid">Generate PDF</base-button>
        <base-button @click="hide" type="flat" class="tw-w-full sm:tw-w-auto tw-mt-2 sm:tw-mt-0">
          Cancel
        </base-button>
      </div>
      <inline-error id="create-pdf-modal-error" :title="errorTitle" :message="errorMessage" :error="error" />
    </base-card>
  </base-modal>
</template>

<script>
import InlineError from "@/components/InlineError";
import BaseSelect from "@/components/base/BaseSelect";

export default {
  components: {
    InlineError,
    BaseSelect,
  },
  data() {
    return {
      businesses: null,
      prescriptions: null,
      isLoading: false,
      isFormValid: true,
      errorTitle: "",
      errorMessage: "",
      error: null,
      isBusinessesLoading: false,
      isPrescriptionLoading: false,
      selectedBusinessId: null,
      selectedPrescriptionId: null,
    };
  },
  computed: {
    formattedPrescriptions() {
      var newPrescriptions = [];

      if (this.prescriptions) {
        for (var prescription of this.prescriptions) {
          var newPrescription = prescription;
          newPrescription.comboName = prescription.memberName + " - " + prescription.programName;
          newPrescriptions.push(newPrescription);
        }
        return newPrescriptions;
      } else return null;
    },
  },
  watch: {
    selectedBusinessId() {
      this.loadPrescriptions(this.selectedBusinessId);
    },
  },
  methods: {
    reset() {
      this.$refs.form.reset();
      this.selectedBusinessId = null;
      this.selectedPrescriptionId = null;
    },
    show() {
      this.$refs.modal.show();
      this.loadBusinesses();
      this.reset();
    },
    hide() {
      this.$refs.modal.hide();
      this.reset();
    },
    loadBusinesses() {
      this.isBusinessesLoading = true;
      this.$axios
        .get("/businesses/list")
        .then((res) => {
          this.businesses = res.data;
        })
        .finally(() => {
          this.isBusinessesLoading = false;
        });
    },
    loadPrescriptions(businessId) {
      this.isPrescriptionsLoading = true;
      this.$axios
        .get(`/businesses/${businessId}/prescriptions/list`)
        .then((res) => {
          this.prescriptions = res.data;
        })
        .finally(() => {
          this.isPrescriptionsLoading = false;
        });
    },
    async save() {
      if (!this.$refs.form.validate()) return;

      var record = this.prescriptions.find((e) => e.businessPrescriptionId === this.selectedPrescriptionId);

      try {
        this.isLoading = true;
        await this.$axios.post(`/businesses/${this.selectedBusinessId}/users/${record.userId}/prescriptions/${this.selectedPrescriptionId}/rxdetails/pdf`);
        this.EventBus.$emit("GLOBAL_NOTIFY", { title: "PDF Requested", message: `The PDF for ${record.memberName} was requested.` });
        this.hide();
      } catch (err) {
        this.errorTitle = `Error communicating with the servers.`;
        this.errorMessage = "Sorry, we had trouble requesting this PDF. The technicians have been notified. Please try again.";
        this.error = err;
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
